import {
  MARKDOWN_IT_RENDERER_SPEC,
  MARKDOWN_RENDERER_DEPS,
  MARKDOWN_RENDERER_DEV_DEPS
} from '@cli-constants/deps.js'
import { detectPackageManager } from '@cli-utils/process.js'
import { spinner } from '@cli-utils/terminal.js'
import { installDependenciesAsync } from '@next-adapter/init/scaffolders/dependencies/install-dependencies-async.js'
import { hasDeclaredPackage } from '@next-adapter/package-json/has-declared-package.js'
import { packageNameFromSpec } from '@next-adapter/package-json/package-name-from-spec.js'
import { readProjectPackageJson } from '@next-adapter/package-json/read-project-package-json.js'
import { hasCompatibleMarkdownItDependency } from './has-compatible-markdown-it-dependency.js'

export async function ensureMarkdownRendererDependencies(
  cwd: string,
  required: boolean
): Promise<void> {
  if (!required) return

  const pkg = readProjectPackageJson(cwd)
  const dependencies = MARKDOWN_RENDERER_DEPS.filter((spec) =>
    spec === MARKDOWN_IT_RENDERER_SPEC
      ? !hasCompatibleMarkdownItDependency(pkg)
      : !hasDeclaredPackage(pkg, packageNameFromSpec(spec), { runtimeOnly: true })
  )
  const devDependencies = MARKDOWN_RENDERER_DEV_DEPS.filter(
    (spec) => !hasDeclaredPackage(pkg, packageNameFromSpec(spec))
  )

  if (dependencies.length === 0 && devDependencies.length === 0) return

  const pm = detectPackageManager(cwd)
  const s = spinner()
  s.start('Installing markdown renderer dependencies')
  const result = await installDependenciesAsync({
    cwd,
    pm,
    dependencies,
    devDependencies
  })

  if (!result.success) {
    s.stop('Failed to install markdown renderer dependencies')
    throw new Error(result.error ?? 'Failed to install markdown renderer dependencies.')
  }

  s.stop(
    `Installed markdown renderer dependencies (${dependencies.length} deps + ${devDependencies.length} dev deps)`
  )
}
